import * as S from './style';

interface ChannelTalkBtnProps {
  bottom?: number;
  onClick?: () => void;
}
export default function ChannelTalkBtn({
  bottom = 76,
  onClick,
}: ChannelTalkBtnProps) {
  function handleClick() {
    if (typeof window !== 'undefined' && window.ChannelIO) {
      window.ChannelIO('showMessenger');
    }
    onClick?.();
  }

  return (
    <S.ChannelTalkButton
      bottom={bottom}
      id='channel-button'
      onClick={handleClick}
    >
      <S.PcImage
        src={process.env.NEXT_PUBLIC_CHTALK_PC || ''}
        alt='채널톡 버튼'
      />
      <S.MobileImage
        src={process.env.NEXT_PUBLIC_CHTALK_MO || ''}
        alt='채널톡 버튼'
      />
    </S.ChannelTalkButton>
  );
}
